import { render, staticRenderFns } from "./CheckObjectMultiLocPlacesInput.vue?vue&type=template&id=488de9ba"
import script from "./CheckObjectMultiLocPlacesInput.vue?vue&type=script&lang=js"
export * from "./CheckObjectMultiLocPlacesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports